import React from 'react'
import style from '../card.module.css'

function Test4() {
  return (
    <div className={style.prepration_card}>
        <h3>NDA Previous Years Questions</h3>
        <button>Free</button> 
        <div>
        <p>Test 4 . Mar 29, 6:30 PM</p>      
        </div>        
    </div>
  )
}

export default Test4